import localStorageService from "@/services/localStorage";
import { Widget } from "@/components/services/participant-service";
import eventBus from "@/eventBus";
let isTeleHealthCallInProgress = false; // For telehealth call session progress or not

const idleLogout = ({ swal, store }) => {
  const widget = new Widget();
  const IDLE_TIMEOUT = 900;
  let idleSecondsCounter = Date.now();

  window.addEventListener("unload", () => {
    localStorageService.setItem("last", Date.now());
    localStorageService.setItem("idleSecondsCounter", idleSecondsCounter);
  });
  window.addEventListener("load", () => {
    const lastTime = +localStorageService.getItem("last");
    const lastIdleSecs = +localStorageService.getItem("idleSecondsCounter");
    const lastAccessTime = parseInt(lastTime / 1000) + lastIdleSecs;
    const dateNow = Date.now() / 1000;
    const dur = dateNow - lastAccessTime;
    if (lastAccessTime > 0 && dur > IDLE_TIMEOUT) {
      if (window.location.href.includes("/participants/web/")) {
        store.dispatch("participantLogout");
      } else {
        store.dispatch("userLogout");
      }
    }
  });
  const resetCounter = () => {
    localStorageService.setItem("last", Date.now());
    idleSecondsCounter = Date.now();
  };
  /**
   * listens for these events from user and resets the idleTime counter
   * removed mouse move, since just moving the mouse over the browser
   * can not be considered as a user activity on application
   */
  ["click", "keypress", "keydown", "keyup", "scroll"].forEach(event => {
    window.document.addEventListener(event, resetCounter);
  });
  // for multiple tabs updated the session or idle time as per current active tab.
  window.addEventListener("storage", e => {
    if (e.isTrusted) {
      resetCounter();
    }
  });

  window.document.getIdleSecondsCounter = () => {
    return idleSecondsCounter;
  };

  function CheckIdleTime() {
    const oPanel = window.document.getElementById("SecondsUntilExpire");
    eventBus.$on("setTeleHelathCallStatus", event => {
      // get the status of a telehealth call session
      isTeleHealthCallInProgress = event;
    });
    
    // Listen for the "CheckModalIdleTime" event on the event bus
    eventBus.$on("CheckModalIdleTime", event => {
      // Check if the event is trusted
      if (event) {
        resetCounter();
      }
    });
    
    const idleDuration = IDLE_TIMEOUT * 1000;
    if (Date.now() >= idleDuration + idleSecondsCounter && oPanel && !isTeleHealthCallInProgress && !document.querySelector("div.swal2-popup.swal2-modal.session-expired.swal2-show")) {
      if (window.location.href.includes("/participants/web/")) {
        store.dispatch("userSessionExpired");
        store.dispatch("participantLogout");
        const message = widget.translate("pweb_session_expire", "Your session has expired due to inactivity. Any unsaved work may not be saved.");
        swal({
          customClass: "session-expired",
          title: message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#34537d",
          confirmButtonText: "OK"
        }).then(() => {
          store.dispatch("userSessionExpired", false);
          store.dispatch("participantLogout");
        });
      } else if (window.location.hash.indexOf("login") < 0 && window.location.hash.indexOf("verify-participant-v2") < 0 && window.location.hash.indexOf("participant-reset-password") < 0) {
        store.dispatch("userSessionExpired");
        store.dispatch("sessionExpiredLogoutUser");
        swal({
          customClass: "session-expired",
          title: "Your session has expired due to inactivity. Any unsaved work may not be saved.",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#34537d",
          confirmButtonText: "OK"
        }).then(
          () => {
            store.dispatch("userSessionExpired", false);
            store.dispatch("userLogout");
          },
          () => {
            store.dispatch("userSessionExpired", false);
            store.dispatch("userLogout");
          }
        );
      } else {
        store.dispatch("userLogout");
      }
    }
  }
  window.setInterval(CheckIdleTime, 1000);
};

export default idleLogout;
